module.exports = __webpack_public_path__ + "img/pen.d7276e3c.svg";